import React, { useState } from 'react';
import './WidgetSettingsNumericValueEditor.scss';
import { RadioGroup } from '@instinet-analytics/semantic-ui-components';

export interface WidgetSettingsRadioGroupValueEditor<
    TKey extends string,
    TConfig extends Record<TKey, string>,
> {
    propertyName: TKey;
    config: TConfig;
    label: string;
    options: { key: TConfig[TKey]; label: string }[];
    onChange: (delta: Partial<TConfig>) => void;
}

export default function WidgetSettingsRadioGroupEditor<
    TKey extends string,
    TConfig extends Record<TKey, string>,
>(props: WidgetSettingsRadioGroupValueEditor<TKey, TConfig>) {
    const { config, onChange, propertyName, label, options } = props;
    const configValue = config[propertyName];

    const [radioValue, setRadioValue] = useState(configValue);

    const onChanged = (nextInputValue: TConfig[TKey]) => {
        setRadioValue(nextInputValue);

        const delta = {
            [propertyName]: nextInputValue,
        } as unknown as Partial<TConfig>;
        onChange(delta);
    };

    return (
        <>
            <div>{label}</div>
            <RadioGroup<TConfig[TKey]>
                selected={radioValue}
                onChange={onChanged}
                options={options}
            />
        </>
    );
}
